import { useRef, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { OnDocumentLoadSuccess } from 'react-pdf/dist/cjs/shared/types';
import { useLockBodyScroll } from 'react-use';

export const PDFDocumentView: React.FC<{ url: string }> = ({ url }) => {
  const [numPages, setNumPages] = useState<number>();
  const [loadError, setLoadError] = useState<string | null>(null);

  const refScrollSection = useRef<HTMLDivElement | null>(null);
  useLockBodyScroll(true, refScrollSection);

  const onDocumentLoadSuccess: OnDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoadError(null);
  };

  const secureUrl = url.replace(/^http:/, 'https:');

  return (
    <div ref={refScrollSection} className="overflow-auto h-full bg-white">
      {loadError ? (
        <div className="flex h-full items-center justify-center text-gray-500">{loadError}</div>
      ) : (
        <Document
          className="flex flex-col items-center"
          file={secureUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(error) => {
            console.error('[PDFDocumentView] load failed', error);
            setLoadError('PDF 加载失败，请稍后重试');
          }}
          loading={<div className="p-8 text-gray-500">PDF 加载中...</div>}
        >
          {numPages &&
            Array(numPages)
              .fill(0)
              .map((_, index) => {
                return <Page width={1000} key={index} pageNumber={index + 1} />;
              })}
        </Document>
      )}
    </div>
  );
};
